import { render, staticRenderFns } from "./PartNumberListContainer.vue?vue&type=template&id=23036aaf&scoped=true"
import script from "./PartNumberListContainer.vue?vue&type=script&lang=js"
export * from "./PartNumberListContainer.vue?vue&type=script&lang=js"
import style0 from "./PartNumberListContainer.vue?vue&type=style&index=0&id=23036aaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23036aaf",
  null
  
)

export default component.exports